/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { buildTheme } from 'src/core/themes/themeBuilder';
import { stylistFactory } from 'stylist-react';

const styleFactory = stylistFactory('Luis', null, buildTheme, { nonce: window.cspNonce });

export const { getStylist, getStylistV2, setTheme, getScopedTheme } = styleFactory;

export { CSSProperties, important, joinClassNames, NestedCSSProperties } from 'stylist-react';
